module.exports = __webpack_public_path__ + "img/luza5.30fd91d7.png";